import React from 'react';

const ReclamationPage = () => {
  return (
    <React.Fragment>
      <h1>Faire reclamation Page</h1>
    </React.Fragment>
  );
};
export default ReclamationPage;
